
import { Vue, Component, Prop, PropSync } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import StaticItem from '@/components/busi/staticitem.vue'
import dayjs from 'dayjs'

@Component({
  name: 'fee',
  components: {
    SimpleTable,
    StaticItem
  }
})
export default class Fee extends Vue {
  private dateFormat (val: any) {
    return (val || val !== '-1' || val !== -1) ? dayjs(val).format('YYYY-MM-DD HH:mm') : ''
  }

  @PropSync('visible', { type: Boolean })
  private dialogVisible!: boolean

  @Prop({ type: Object })
  private data!: object|any

  private timeConvert (timeStamp: number) {
    return !timeStamp ? '' : dayjs(timeStamp).format('YYYY-MM-DD HH:mm')
  }

  private pagination = null

  private loading = !1

  private title = ''

  get tradeType () {
    const dict: any = {
      1: 'sf',
      2: 'tf',
      4: 'jm',
      3: 'yf'
    }
    return dict[this.data.info.tradeType] || '-'
  }

  private columns = {
    '-': [
      {
        prop: 'itemName',
        label: '收费项目'
      },
      {
        prop: 'feeRangeBegin',
        label: '收费区间起'
      },
      {
        prop: 'feeRangeEnd',
        label: '收费区间止'
      },
      {
        prop: 'feeMust',
        label: '必缴'
      },
      {
        prop: 'receivableMoney',
        label: '应收'
      },
      {
        prop: 'acceptedMoney',
        label: '已收'
      },
      {
        prop: 'reduceSum',
        label: '已减免'
      },
      {
        prop: 'cash',
        label: '现金'
      },
      {
        prop: 'brushCard',
        label: '刷卡'
      },
      {
        prop: 'transferMoney',
        label: '转账'
      },
      {
        prop: 'aliPay',
        label: '支付宝'
      },
      {
        prop: 'wechatOnlinePay',
        label: '代理小程序'
      },
      {
        prop: 'weChatPay',
        label: '微信'
      },
      {
        prop: 'oneCodePay',
        label: '一码通'
      },
      {
        prop: 'payPlatform',
        label: '缴平台'
      },
      {
        prop: 'xtPay',
        label: '秀推'
      },
      {
        prop: 'acceptedMoney',
        label: '实收'
      }
    ],
    sf: [
      {
        prop: 'schoolName',
        label: '院校名称'
      },
      {
        prop: 'gradeName',
        label: '年级名称'
      },
      {
        prop: 'subjectName',
        label: '专业名称'
      },
      {
        prop: 'feeItemName',
        label: '收费项目'
      },
      {
        prop: 'schoolYearName',
        label: '学年'
      },
      {
        prop: 'feeMustName',
        label: '必缴'
      },
      {
        prop: 'receivableAmount',
        label: '应收'
      },
      {
        prop: 'acceptedAmount',
        label: '已收'
      },
      {
        prop: 'alreadyReductionAmount',
        label: '已减免'
      },
      {
        prop: 'alreadyRefundAmount',
        label: '已退'
      },
      {
        prop: 'payAmount',
        label: '本次收款'
      },
      {
        prop: 'amount',
        label: '本次到账'
      },
      {
        prop: 'arrearsAmount',
        label: '欠费'
      }
    ],
    yf: [
      {
        prop: 'schoolName',
        label: '院校名称'
      },
      {
        prop: 'gradeName',
        label: '年级名称'
      },
      {
        prop: 'subjectName',
        label: '专业名称'
      },
      {
        prop: 'feeItemName',
        label: '收费项目'
      },
      {
        prop: 'schoolYearName',
        label: '学年'
      },
      {
        prop: 'feeMustName',
        label: '必缴'
      },
      {
        prop: 'receivableAmount',
        label: '应收'
      },
      {
        prop: 'acceptedAmount',
        label: '已收'
      },
      {
        prop: 'alreadyReductionAmount',
        label: '已减免'
      },
      {
        prop: 'payAmount',
        label: '本次预收'
      },
      {
        prop: 'amount',
        label: '本次到账金额'
      }
    ],
    tf: [
      {
        prop: 'schoolName',
        label: '院校名称'
      },
      {
        prop: 'gradeName',
        label: '年级名称'
      },
      {
        prop: 'subjectName',
        label: '专业名称'
      },
      {
        prop: 'feeItemName',
        label: '收费项目'
      },
      {
        prop: 'schoolYearName',
        label: '学年'
      },
      {
        prop: 'feeMustName',
        label: '必缴'
      },
      {
        prop: 'receivableAmount',
        label: '应收'
      },
      {
        prop: 'acceptedAmount',
        label: '已收'
      },
      {
        prop: 'alreadyRefundAmount',
        label: '已退'
      },
      {
        prop: 'alreadyReductionAmount',
        label: '已减免'
      },
      {
        prop: 'surplusRefundAmount',
        label: '余额退款'
      },
      {
        prop: 'refundAmount',
        label: '本次退费'
      }
    ],
    jm: [
      {
        prop: 'schoolName',
        label: '院校名称'
      },
      {
        prop: 'gradeName',
        label: '年级名称'
      },
      {
        prop: 'subjectName',
        label: '专业名称'
      },
      {
        prop: 'feeItemName',
        label: '收费项目'
      },
      {
        prop: 'schoolYearName',
        label: '学年'
      },
      {
        prop: 'feeMustName',
        label: '必缴'
      },
      {
        prop: 'receivableAmount',
        label: '应收'
      },
      {
        prop: 'alreadyReductionAmount',
        label: '已减免'
      },
      {
        prop: 'reductionAmount',
        label: '本次减免'
      }
    ]
  }

  private tableData = {
    list: [],
    totalCount: 1
  }

  private open () {
    if (!this.data.info) return
    Object.keys(this.data.info).map((key: any) => {
      if (key.indexOf('Amount') > -1 || key.indexOf('amount') > -1) {
        this.data.info[key] = this.data.info[key] / 100
      }
    })
    this.data.info.cash = this.data.info.cash / 100
    this.data.info.brushCard = this.data.info.brushCard / 100
    this.data.info.transferMoney = this.data.info.transferMoney / 100
    this.data.info.aliPay = this.data.info.aliPay / 100
    this.data.info.wechatPay = this.data.info.wechatPay / 100
    this.data.info.oneCodePay = this.data.info.oneCodePay / 100
    this.data.info.payPlatform = this.data.info.payPlatform / 100
    this.data.info.xtPay = this.data.info.xtPay / 100
    this.data.info.wechatOnlinePay = this.data.info.wechatOnlinePay / 100
    this.title = `${this.data.info.tradeTypeName}明细详情`
    this.tableData.list = this.data.list.map((v: any) => {
      Object.keys(v).map((key: any) => {
        if (key.indexOf('Amount') > -1 || key.indexOf('amount') > -1) {
          v[key] = v[key] / 100
        }
      })
      return v
    })
    this.tableData.totalCount = this.data.list.length
  }
}
